import * as React from "react";
import {translate} from "react-i18next";
import {connect, Dispatch} from "react-redux";

// services
import {MenuDto, ResourceListOfGroupDto, UserDetailsDto, UserDto,} from "../../../services/Client";

// reducer
import {ITranslatedComponent} from "../../../redux/reducers/generalReducer";

// semantic
import {Table} from "semantic-ui-react";

import DetailsDialog from "./DetailsDialog";
import {renderErrorToast} from "../../../utils/FeedbackMessageUtils";
import HATEOASClient from "../../../services/HATEOASClient";
import {compose} from "redux";
import {selectAdminArealinks, selectClient} from "../../../redux/selectors";
import {IReduxState} from "../../../redux/IReduxState";
import AdminViewActions from "../../../redux/actions/AdminViewActions";

interface IMapStateToProps {
    adminAreaLinks?: MenuDto;
    client: HATEOASClient;
}

interface IMapDispatchToProps {
    changeActiveAccesTab: (
        accessTabAndFilter: {
            activeIndex: number;
            filter?: string;
        }) => void;
}

interface IOwnProps {
    /** The user to display. */
    user: UserDto;

    /** Callback when the user closes the dialog. */
    onClose?: () => void;
}

interface IUserDetailsDialogProps extends
    IOwnProps,
    IMapStateToProps,
    IMapDispatchToProps,
    ITranslatedComponent { }

interface IUserDetailsDialogState {
    directParentGroups?: ResourceListOfGroupDto;
    indirectParentGroups?: ResourceListOfGroupDto;
}

/**
 * Shows the detail information of a specific user in a modal dialog.
 */
class UserDetailsDialog extends React.Component<IUserDetailsDialogProps, IUserDetailsDialogState> {

    constructor(props: IUserDetailsDialogProps) {
        super(props);

        this.state = {
            directParentGroups: undefined,
            indirectParentGroups: undefined,
        };
    }

    renderAccessRights = ({cnrs, typefamilies, modelyears}: any): JSX.Element => {

        const getAccessRights = (data: any, combineName = false,isCnr=false) => {
            let combineGroups: any[] = [];

            data.map((el: any) => {
                if (el.permissionType.substring(0, 4) === "LDAP") {
                    combineGroups.push(
                        <span
                            style={{
                                color: ' rgb(255, 139, 0)',
                                border: '1.5px solid',
                                margin: '2px',
                                padding: '1px'
                            }}
                        >
                            {combineName ? `${el.mj4}(${el.mj1})` : isCnr ? this.props.t(`GLOBAL:${el.cnr}`):el.name}
                        </span>
                    );
                } else if (el.permissionType.substring(0, 6) === "PRO_MT") {
                    combineGroups.push(
                        <span
                            style={{
                                color: 'rgb(76, 154, 255)',
                                border: '1.5px solid',
                                margin: '2px',
                                padding: '1px'
                            }}
                        >
                            {combineName ? `${el.mj4}(${el.mj1})` : isCnr ? this.props.t(`GLOBAL:${el.cnr}`):el.name}
                        </span>
                    );
                }
                else combineGroups.push(
                    <span
                        style={{
                            fontWeight: 'bold',
                            border: '1.5px solid',
                            margin: '2px',
                            padding: '1px'
                        }}
                    >
                        {combineName ? `${el.mj4}(${el.mj1})` : isCnr ? this.props.t(`GLOBAL:${el.cnr}`):el.name}
                    </span>
                );
            });

            return combineGroups;
        };

        return (
            <Table
                style={{
                    borderCollapse: 'collapse',
                    borderColor: '#fff'
                }}
            >
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{this.props.t("MODELYEARS")}</Table.Cell>
                        <Table.Cell
                            className="display--flex flex--wrap"
                        >
                            {...getAccessRights(modelyears, true,false)}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("TYPEFAMILIES")}</Table.Cell>
                        <Table.Cell
                            className="display--flex flex--wrap"
                        >
                            {...getAccessRights(typefamilies,false,false)}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("CNRS")}</Table.Cell>
                        <Table.Cell
                            className="display--flex flex--wrap"
                        >
                            {...getAccessRights(cnrs,false,true)}
                        </Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }

    renderGroups = ({userGroups}: any) => {
        let groups: any[] = [];
        let groupTypes: string[] = ['LDAP', 'LDAP_PARENT', 'PRO_MT_LDAP', 'PRO_MT_LDAP_PARENT'];

        groups = userGroups && userGroups.map((group: any, i: any) => {
            if (groupTypes.includes(group.groupType)) {
                return (
                    <span
                        className='bold'
                        style={{cursor: 'pointer'}}
                        onClick={() => this.props.changeActiveAccesTab({activeIndex: 1, filter: group.groupName})}
                    >
                        {`${group.groupName}${userGroups.length - 1 === i ? '' : ', '}`}
                    </span>
                );
            } else {
                return <span>{`${group.groupName}${userGroups.length - 1 === i ? '' : ', '}`}</span>;
            }
        });

        return groups;
    }

    renderIndirectParentGroups = () => {
        let groups: any[] = [];
        let allGroups: any[] = [];
        let directParentGroups: any[] = [];
        let indirectParentGroups: any[] = [];

        if (this.state.indirectParentGroups && this.state.indirectParentGroups.elements) {
            this.state.indirectParentGroups.elements.map(groupDto => {
                indirectParentGroups.push({key: 'indirectParentGroups', value: groupDto.groupName});
            });
        }

        if (this.state.directParentGroups && this.state.directParentGroups.elements) {
            this.state.directParentGroups.elements.map(groupDto => {
                directParentGroups.push({key: 'directParentGroups', value: groupDto.groupName});
            });
        }

        directParentGroups = directParentGroups.filter(group => {
            for (let element of indirectParentGroups) {
                if (element.value === group.value) {
                    return false;
                }
            }
            return true;
        });

        allGroups = indirectParentGroups.concat(directParentGroups);

        groups = allGroups && allGroups.map((group: {key: any, value: any}, i: any) => {
            if (group.key === ('indirectParentGroups')) {
                return (
                    <span
                        className='bold'
                        style={{cursor: 'pointer'}}
                        onClick={() => this.props.changeActiveAccesTab({activeIndex: 1, filter: group.value})}
                    >
                        {`${group.value}${allGroups.length - 1 === i ? '' : ', '}`}
                    </span>
                );
            } else {
                return <span>{`${group.value}${allGroups.length - 1 === i ? '' : ', '}`}</span>;
            }
        });

        return groups;
    }

    renderDetails = (details?: UserDetailsDto): JSX.Element => {
        return (
            <Table definition={true}>
                <Table.Body>
                    <Table.Row>
                        <Table.Cell>{this.props.t("CN")}</Table.Cell>
                        <Table.Cell>{details && details.cn && details.cn}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("REPRESENTED_USERS")}</Table.Cell>
                        <Table.Cell>{details && details.representedUsers && details.representedUsers.join(", ")}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("DISPLAY_NAME")}</Table.Cell>
                        <Table.Cell>{details && details.displayName && details.displayName}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("DEPARTMENT")}</Table.Cell>
                        <Table.Cell>{details && details.department && details.department}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("EMAIL")}</Table.Cell>
                        <Table.Cell>{details && details.email && details.email}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("GROUPS")}</Table.Cell>
                        <Table.Cell>{details && this.renderGroups(details).map(el => el)}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("MEMBER_OF")}</Table.Cell>
                        <Table.Cell>
                            <div>{this.renderIndirectParentGroups().map(el => el)}</div>
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell> {this.props.t("PRIVILEGES")} </Table.Cell>
                        <Table.Cell>{details && details.privileges && details.privileges.map(privilege => privilege.identifier).join(", ")}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("ACCESS_RIGHTS")}</Table.Cell>
                        <Table.Cell style={{padding: '0'}}>
                            {details && this.renderAccessRights(details)}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                        <Table.Cell>{this.props.t("LAST_LOGIN")}</Table.Cell>
                        <Table.Cell>{details && details.lastLogin !== undefined && details.lastLogin !== 0 && (new Date(details.lastLogin)).toLocaleDateString()}</Table.Cell>
                    </Table.Row>
                </Table.Body>
            </Table>
        );
    }

    componentDidMount() {
        // TODO something here throws an error from React
        // because of the promises
        // "Can't call setState (or forceUpdate) on an unmounted component."
        this.requestDirectParentGroups();
        this.requestIndirectParentGroups();
    }

    requestDirectParentGroups() {
        if (this.props.adminAreaLinks) {
            this.props.client.GET_directParentGroups(this.props.adminAreaLinks).execute({userCn: this.props.user.cn})
                .then((response: any) => {
                    this.setState({directParentGroups: response});
                })
                .catch((reason: any) => {
                    renderErrorToast(
                        {
                            message: "ERRORS:REQUEST_DETAILS_FAILED",
                            details: reason,
                            timestamp: Date.now(),
                        }
                    );
                });
        }
    }

    requestIndirectParentGroups() {
        if (this.props.adminAreaLinks) {
            this.props.client.GET_indirectParentGroups(this.props.adminAreaLinks).execute({userCn: this.props.user.cn})
                .then((response: any) => {
                    this.setState({indirectParentGroups: response});
                })
                .catch((reason: any) => {
                    renderErrorToast(
                        {
                            message: "ERRORS:REQUEST_DETAILS_FAILED",
                            details: reason,
                            timestamp: Date.now(),
                        }
                    );
                });
        }
    }

    render() {
        return (
            <DetailsDialog
                headerText={this.props.t("USER_DETAILS")}
                onRequestDetails={() => this.props.client.GET_userDetails(this.props.user).execute(this.props.user.cn)}
                onRender={this.renderDetails}
                onClose={() => this.props.onClose && this.props.onClose()}
            />
        );
    }
}

const mapStateToProps = (state: IReduxState): IMapStateToProps => ({
    adminAreaLinks: selectAdminArealinks(state),
    client: selectClient(state),
});

const mapDispatchToProps = (dispacht: Dispatch<IReduxState>): IMapDispatchToProps => ({
    changeActiveAccesTab: (activeIndex) => dispacht(AdminViewActions.ChangeActiveAccesTab(activeIndex))
});

export default compose<React.ComponentType<IOwnProps>>(
    translate("ADMIN_VIEW"),
    connect<IMapStateToProps, IMapDispatchToProps>(mapStateToProps, mapDispatchToProps)
)(UserDetailsDialog);



// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/UserDetailsDialog.tsx